import { Spin } from '@weapp/ui';

function ModuleLoading(props: any) {
  return (
    <Spin size="large" weId={`${props.weId || ''}_ndzvnt`}><div style={{ height: 'calc(100vh - 50px)' }}></div></Spin>
  );
}

export default ModuleLoading;